import { createSlice } from "@reduxjs/toolkit";
import { CollaborationLegacySlice } from "types/collaboration-legacy";
import { fetchLegacyCollaborationsListThunk, fetchLegacyCollaborationThunk } from "./thunk";

const initialState: CollaborationLegacySlice = {
    loading: false,
    filtered_lists: {},
    total: 0,
    filters: {
        page: 1,
        q: ''
    },
    applied_filter_id: null,
    items: {},
    itemLoading: false
}

const collaborationsLegacy = createSlice({
    name: 'legacyCollaborations',
    initialState,
    reducers: {
        updateLegacyCollaborationsListFilters: (state, action) => {
            state.filters = action.payload
        },
        searchLegacyCollaborationsList: (state, action) => {
            state.filters.q = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLegacyCollaborationsListThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchLegacyCollaborationsListThunk.fulfilled, (state, { payload }) => {
                const { count, items, filterId, filters } = payload;
                const existingList = state.filtered_lists?.[filterId]?.list ?? [];
                const list = filters.page === 1 ? items : [...existingList, ...items]
                state.filtered_lists = {
                    ...state.filtered_lists,
                    [filterId]: {
                        list,
                        page: filters.page,
                        expired: false,
                        last_fetched_at: Date.now(),
                        has_more: count > list.length,
                        count
                    }
                }
                state.applied_filter_id = filterId
                state.total = count
                state.loading = false
            })
            .addCase(fetchLegacyCollaborationsListThunk.rejected, (state) => {
                state.loading = false
            })

            .addCase(fetchLegacyCollaborationThunk.pending, (state) => {
                state.itemLoading = true
            })
            .addCase(fetchLegacyCollaborationThunk.fulfilled, (state, { payload }) => {
                const { cache, campaignId, collaborationId, collaboration, chat } = payload;

                state.items[campaignId] = {
                    ...(state.items[campaignId] ?? {}),
                    [collaborationId]: {
                        ...(state.items[campaignId]?.[collaborationId] ?? {}),
                        collaboration,
                        chat,
                        expired: false,
                        ...(!cache ? { last_fetched_at: Date.now() } : {})
                    }
                }

                state.itemLoading = false;

            })
            .addCase(fetchLegacyCollaborationThunk.rejected, (state) => {
                state.itemLoading = false;
            })
    }
})

export const { updateLegacyCollaborationsListFilters, searchLegacyCollaborationsList } = collaborationsLegacy.actions
export default collaborationsLegacy.reducer